// src/services/getAuthToken.js (or place it within api.js if preferred)

// Import your initialized Supabase client
// Adjust the path based on your project structure
import { supabase } from '../supabaseClient'; // e.g., '../supabaseClient' or './supabaseClient'

/**
 * Asynchronously retrieves the current user's JWT access token from Supabase.
 *
 * @returns {Promise<string | null>} A promise that resolves with the access token string,
 * or null if no active session or token exists, or if an error occurs.
 */
export const getAuthToken = async () => {
  try {
    // Get the current session data from Supabase
    const { data, error } = await supabase.auth.getSession();

    // Handle potential errors during session retrieval
    if (error) {
      console.error("Error getting Supabase session:", error.message);
      return null; // Return null on error
    }

    // Check if a session and access token exist
    if (data.session && data.session.access_token) {
      // console.log("Supabase session found. Returning access token."); // Optional: for debugging
      return data.session.access_token;
    } else {
      // console.log("No active Supabase session or access token found."); // Optional: for debugging
      return null; // No active session or token
    }
  } catch (catchError) {
    // Catch any unexpected errors during the process
    console.error("Unexpected error in getAuthToken:", catchError);
    return null;
  }
};

// Example usage (demonstration, not needed in the final function file):
/*
async function testToken() {
  console.log("Attempting to get token...");
  const token = await getAuthToken();
  if (token) {
    console.log("Retrieved Token (first few chars):", token.substring(0, 10) + "...");
  } else {
    console.log("Could not retrieve token (not logged in or error).");
  }
}

// Call the test function (only for testing purposes)
// testToken();
*/

